import KeenSlider from 'keen-slider'
import { useEffect, useRef } from 'react'

const useAutoplay = (time: number, slider: KeenSlider) => {
  const timer: any = useRef()
  useEffect(() => {
    timer.current = setInterval(() => {
      if (slider) slider.next()
    }, time)
    return () => {
      clearInterval(timer.current)
    }
  }, [slider])
}
export default useAutoplay
